import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { instrumenter } from '~/client/utils/instrumentation'
import { useExperimentation } from 'client/hooks/useExperimentation'
import { boostsSelector } from '~/client/store/boosts'
import { BOOST_VARIATIONS } from '~/shared/experiments/DesignBoost/constants'
import { LOGOMAKER_CTA_VARIATIONS } from '~/shared/experiments/LogomakerCTA/constants'
import { DIFY_TILE_TEST } from '~/shared/experiments/DifyTileTest/constants'
import { FIRST_IMPRESSION_VARIATIONS } from '~/shared/experiments/ASPSearch/FirstImpressionExperiment'
import { NOTECARDS_PDP_FLOW_TEST } from '~/shared/experiments/NoteCardsPDPFlowTest/constants'

export const useInitExperiments = (): void => {
  const boosts = useSelector(boostsSelector)

  const isExperimentActive = useExperimentation()

  useEffect(() => {
    // Fire experiment impression event for server side experiments
    instrumenter.recordAppHydratedEvent()
    if (boosts && (boosts.boostedCategories.length > 0 || boosts.boostedKeywords.length > 0)) {
      isExperimentActive(BOOST_VARIATIONS.Control)
      isExperimentActive(BOOST_VARIATIONS.Enabled)
    }
    isExperimentActive(LOGOMAKER_CTA_VARIATIONS.Enabled)
    isExperimentActive(LOGOMAKER_CTA_VARIATIONS.Control)
    isExperimentActive(DIFY_TILE_TEST.Enabled1)
    isExperimentActive(DIFY_TILE_TEST.Enabled2)
    isExperimentActive(DIFY_TILE_TEST.Control)
    isExperimentActive(NOTECARDS_PDP_FLOW_TEST.Control)
    isExperimentActive(FIRST_IMPRESSION_VARIATIONS.FirstImpressionTestControl)
    isExperimentActive(FIRST_IMPRESSION_VARIATIONS.FirstImpressionTestEnabled)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
